import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import { clearCard } from "../Actions/CheckoutAction"
import { Link } from 'react-router-dom'

const mapStateToProps = (state) => {
    return {
        helpRed: state.HelpReducer
    }
}

const mapDispatchToProps = dispatch => ({
    clearCard: () => dispatch(clearCard())
});

class BookingSucess extends Component {

    constructor(props) {
        super(props);

        this.props.clearCard()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <Fragment>

                <Helmet
                    title="Payment Success"
                    description="Payment completed successfully"
                />

                <Header Home={false} />

                <div className="container" style={{ padding: '80px 0' }}>

                    <div
                        style={{
                            maxWidth: 700,
                            margin: '0 auto',
                            textAlign: 'center',
                            background: '#fff',
                            padding: 50,
                            borderRadius: 10,
                            boxShadow: '0 2px 15px rgba(0,0,0,0.1)'
                        }}
                    >

                        <div
                            style={{
                                width: 100,
                                height: 100,
                                borderRadius: '50%',
                                background: '#28a745',
                                margin: '0 auto 25px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 50,
                                color: '#fff'
                            }}
                        >
                            ✓
                        </div>

                        <h1
                            style={{
                                fontSize: 36,
                                fontWeight: 700,
                                marginBottom: 20
                            }}
                        >
                            Booking successful
                        </h1>

                        <p
                            style={{
                                fontSize: 18,
                                color: '#666',
                                marginBottom: 35,
                                lineHeight: 1.7
                            }}
                        >
                            Thank you for your booking.
                            Your booking has been completed successfully.
                        </p>

                        <Link
                            to="/"
                            className="btn btn-primary"
                            style={{
                                padding: '12px 35px',
                                fontSize: 16,
                                borderRadius: 5,
                                backgroundColor:'#466ca1',
                                borderColor:'#325d9a',
                            }}
                        >
                            Back To Home
                        </Link>

                    </div>

                </div>

                <Footer />

            </Fragment>
        )
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(BookingSucess);